import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ContactForm = ({
  onFillEnd,
  onFocusChange,
  onMessageFocus,
  onButtonHover,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFillEnd(formData);
  };

  const handleFocus = () => {
    if (onFocusChange) onFocusChange(true);
  };

  const handleBlur = () => {
    if (onFocusChange) onFocusChange(false);
    if (onMessageFocus) onMessageFocus(false); // Also clear message focus on blur
  };

  // Specific handlers for message field
  const handleMessageFocus = () => {
    handleFocus(); // Still trigger general focus
    if (onMessageFocus) onMessageFocus(true);
  };

  const handleMessageBlur = () => {
    handleBlur(); // Still trigger general blur
  };

  const inputStyle = {
    width: "100%",
    background: "transparent",
    border: "none",
    borderBottom: "1px solid #333",
    padding: "10px 0",
    fontSize: "1rem",
    fontFamily: "inherit",
    marginBottom: "30px",
    outline: "none",
    borderRadius: 0,
  };

  const labelStyle = {
    display: "block",
    fontSize: "0.8rem",
    textTransform: "uppercase",
    marginBottom: "5px",
    color: "#666",
    fontFamily: "monospace",
  };

  const groupStyle = {
    marginBottom: "20px",
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        padding: "20px",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <p
          style={{
            fontSize: "1.2rem",
            marginBottom: "40px",
            lineHeight: "1.6",
          }}
        >
          {t("contact.formIntro")}
        </p>
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t("contact.nameLabel")}</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required
          style={inputStyle}
          placeholder={t("contact.namePlaceholder")}
        />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t("contact.emailLabel")}</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required
          style={inputStyle}
          placeholder={t("contact.emailPlaceholder")}
        />
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t("contact.messageLabel")}</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          onFocus={handleMessageFocus}
          onBlur={handleMessageBlur}
          rows="1"
          style={{ ...inputStyle, resize: "none" }}
          placeholder={t("contact.messagePlaceholder")}
        />
      </div>

      <button
        type="submit"
        style={{
          alignSelf: "flex-start",
          background: "#eb5939",
          color: "#fff",
          border: "none",
          padding: "15px 40px",
          fontSize: "1rem",
          cursor: "pointer",
          borderRadius: "30px",
          textTransform: "uppercase",
          letterSpacing: "1px",
          marginTop: "20px",
          transition: "transform 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "scale(1.05)";
          if (onButtonHover) onButtonHover(true);
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "scale(1)";
          if (onButtonHover) onButtonHover(false);
        }}
      >
        {t("contact.submitButton")}
      </button>
    </form>
  );
};

export default ContactForm;
